.span {
  display: inline-block;
}

:root {
  & > *,
  & > *::before,
  & > ::after {
    box-sizing: border-box;
  }
}

.icon {
  position: absolute;
}

.anchor-c-checkbox {
  background: transparent;
  --cursor: pointer;
  --background: var(--s-color-background-default-default);
  --text-color: var(--s-color-text-default);
  --primary-radius: var(--s-size-radius-medium);
  --border-width: var(--s-size-border-width-default);
  --outer-box-padding: 3px;
  --checkbox-size: var(--p-size-static-300);
  display: flex;
  position: relative;
  cursor: var(--cursor);
  outline: 0;

  &--input {
    --color: var(--s-color-background-default-default);
    --border-color: var(--b-color-neutral-darker);
    margin: 0;
    appearance: none;
    pointer-events: none;
    background-color: var(--color);
    border: var(--border-width) solid var(--border-color);
    border-radius: var(--primary-radius);
    height: var(--checkbox-size);
    min-width: var(--checkbox-size);
    &:checked,
    &.indeterminate {
      --color: var(--b-color-neutral-darker);
      &:hover {
        --color: var(--b-color-black);
      }
    }
    &:disabled {
      --border-color: var(--p-color-stone-400);
      --cursor: not-allowed;
    }
    &:disabled:checked {
      --color: var(--p-color-stone-400);
    }
  }

  &:focus-visible {
    .anchor-c-checkbox--input:not(:disabled) {
      --border-color: var(--s-color-outline-default);
      outline: var(--s-color-outline-default) solid var(--s-size-outline-focus-ring-width);
      outline-offset: var(--s-size-outline-focus-ring-offset);
    }
  }
  &:hover {
    .anchor-c-checkbox--input:not(:disabled) {
      --border-color: var(--b-color-black);
      outline: var(--s-color-outline-aura-hover) solid var(--s-size-outline-aura-width);
    }
  }
  &:active {
    .anchor-c-checkbox--input {
      outline-color: var(--s-color-outline-aura-pressed);
    }
  }

  label {
    font-family: inherit;
    font-size: var(--s-size-text-default);
    line-height: var(--p-size-dynamic-300);
    padding: var(--p-size-static-150) 0;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: var(--p-size-static-200);
    color: var(--text-color);

    &:hover {
      cursor: var(--cursor);
    }
    ::slotted([slot|='help-text']) {
      display: block;
      font-weight: 300;
    }
  }

  &--background {
    background: var(--background);
    border-radius: var(--primary-radius);
    label {
      padding: var(--p-size-static-150);
    }
  }

  &--disabled {
    --text-color: var(--s-color-text-disabled);
    label:hover {
      --cursor: not-allowed;
    }
  }
}
